"use strict";

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */

var react_1 = require("react");

var getValue = function getValue(search, param) {
  return new URLSearchParams(search).get(param);
};

var useSearchParam = function useSearchParam(param) {
  var _a = react_1.useState(function () {
    return getValue(location.search, param);
  }),
      value = _a[0],
      setValue = _a[1];

  react_1.useEffect(function () {
    var onChange = function onChange() {
      setValue(getValue(location.search, param));
    };

    window.addEventListener('popstate', onChange);
    window.addEventListener('pushstate', onChange);
    window.addEventListener('replacestate', onChange);
    return function () {
      window.removeEventListener('popstate', onChange);
      window.removeEventListener('pushstate', onChange);
      window.removeEventListener('replacestate', onChange);
    };
  }, []);
  return value;
};

var useSearchParamServer = function useSearchParamServer() {
  return null;
};

exports["default"] = typeof window === 'object' ? useSearchParam : useSearchParamServer;